import {
  ConfirmKlarnaPaymentMutation,
  ConfirmKlarnaPaymentMutationVariables,
} from '@/types';
import { gql, useMutation } from '@apollo/client';

export const CONFIRM_KLARNA_PAYMENT_MUTATION = gql`
  mutation ConfirmKlarnaPayment(
    $restaurantId: uuid!
    $supplierId: uuid!
    $paymentBatchId: uuid!
    $klarnaPaymentData: String
    $klarnaPaymentDetails: String!
  ) {
    confirmKlarnaPayment(
      restaurant_id: $restaurantId
      supplier_id: $supplierId
      payment_batch_id: $paymentBatchId
      klarna_payment_data: $klarnaPaymentData
      klarna_payment_details: $klarnaPaymentDetails
    ) {
      alert_level
      alert_message
      payment_batch_id
      payment_batch {
        result_code
      }
    }
  }
`;

export const useConfirmKlarnaPayment = () =>
  useMutation<
    ConfirmKlarnaPaymentMutation,
    ConfirmKlarnaPaymentMutationVariables
  >(CONFIRM_KLARNA_PAYMENT_MUTATION);
